import { forwardRef } from "react";
import { styled } from "@mui/material";
import { MapContainer, MapContainerProps } from "react-leaflet";

import { useCurrentMapBounds } from "hooks/mapHooks";

import { MapSizeObserver } from "./utils/MapSizeObserver";
import { PersistMapPosition } from "./utils/PersistMapPosition";
import { SelectBaseLayersControl } from "./layers/select/SelectBaseLayersControl";
import { RenderOverlayers } from "./layers/RenderOverlayers";
import { RenderBackgroundLayer } from "./layers/RenderBackgroundLayer";
import { FullscreenControl } from "./FullScreenControl";
import { MapZoomControls } from "./MapZoomControls";
import { AttributionAndScale } from "./attribution/AttributionAndScale";
import { SearchControl } from "./search/SearchControl";

interface Props extends MapContainerProps {
  uuid?: string;
}

export const MapContent = forwardRef((props: Props, ref) => {
  const { children, uuid } = props;
  const bounds = useCurrentMapBounds();

  return (
    <StyledMapContainer
      bounds={bounds}
      zoomControl={false}
      attributionControl={false}
      preferCanvas={true}
      maxZoom={18}
    >
      <PersistMapPosition />
      <MapSizeObserver />
      <RenderBackgroundLayer />
      <RenderOverlayers />
      <AttributionAndScale position="bottomright" uuid={uuid} />
      <MapZoomControls position="bottomright" />
      <FullscreenControl position="bottomright" />
      {children}
      <SearchControl position="topright" />
      <SelectBaseLayersControl position="topright" />
    </StyledMapContainer>
  );
});

const StyledMapContainer = styled(MapContainer)`
  .leaflet-right .leaflet-control.flush-to-edge {
    margin-right: 0px;
  }
  .leaflet-bottom .leaflet-control.flush-to-edge {
    margin-bottom: 0px;
  }
  .leaflet-left .leaflet-control.flush-to-edge {
    margin-left: 0px;
  }
  .leaflet-top .leaflet-control.flush-to-edge {
    margin-top: 0px;
  }
`;
